import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import common from './locales/en/common.json';
export const defaultNS = 'common';
export const resources = {
  en: {
    common,
  },
} as const;

void i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  ns: ['common'],
  defaultNS,
  resources,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
});
